import React, {useEffect, useMemo, useState} from 'react';
import TableSelect from "../TableSelect";
import {useRowSelect, useTable} from "react-table";
import {Checkbox} from "../Checkbox";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faArrowDown, faCheck, faXmark} from "@fortawesome/free-solid-svg-icons";
import OverviewAPI from "../../api/OverviewAPI";
import TableSkeleton from "../skeletons/TableSkeleton";
import UtcToLocal from "../UtcToLocal";
import TransactionDetails from '../TransactionDetails';
import {useDispatch, useSelector} from 'react-redux';
import {useOutletContext} from 'react-router-dom';
import {setActionPayload, setActionType} from '../../features/authorizationSlice';
import {ACTION_TYPES} from "../../app/actionTypes";
import {formatLBP, formatUSD} from "../../features/ValueFormater";


function ApprovalList() {
    const [activeRowIndex, setActiveRowIndex] = useState(-1);
    const [visible, setVisible] = useState(false);
    const [amountDetails, setAmountDetails] = useState(null);

    const {GetTransactionsToApprove, transactionsToApprove, approveListLoading} = OverviewAPI();
    const dispatch = useDispatch();
    const [onOpenQrAfterGenerate] = useOutletContext();

    const {status} = useSelector((state) => state.authorization);

    useEffect(() => {
        GetTransactionsToApprove()
    }, []);

    useEffect(() => {
        if(status==="Complete"){
            GetTransactionsToApprove()
        }
    }, [status]);

    const data = useMemo(() => transactionsToApprove, [transactionsToApprove]);

    const options = {
        weekday: 'short',
        day: 'numeric',
        month: 'short',
        year: 'numeric'
    };

    const handleApprove = async () => {
        const payload = {
            transactionIds: selectedFlatRows.map((row) => row.original.Transaction)
        }

        dispatch(setActionType(ACTION_TYPES.APPROVE_LIST_TRX));
        dispatch(setActionPayload(payload));

        onOpenQrAfterGenerate();
    };

    const handleApproveDecline = async (transactionId, status) => {
        const payload = {
            TransactionID: transactionId,
            Status: status,
        }

        dispatch(setActionType(ACTION_TYPES.APPROVE_TRX));
        dispatch(setActionPayload(payload));

        onOpenQrAfterGenerate();
    }


    const columns = useMemo(
        () => [
            {
                Header: "Transaction",
                accessor: "Transaction"
            },
            {
                Header: "",
                accessor: "details",
                Cell: ({row}) => {
                    return <button className="showmore" onClick={() => {
                        setActiveRowIndex(row.index)
                    }}><FontAwesomeIcon icon={faArrowDown}/></button>
                },
            },
            {
                Header: "Payment Date",
                accessor: "PaymentDate",
                Cell: ({cell: {value}}) => (
                    <UtcToLocal utcTimestamp={value} options={options}/>
                )
            },
            {
                Header: "Method",
                accessor: "Method",
            },
            {
                Header: "Amount",
                accessor: "Amount",
                Cell: ({cell: {row, value}}) => {
                    return <span
                        style={{color: "red", fontFamily: "Poppins Bold ", fontSize: "14px"}}>{row.original.CurrencyID===1? "-$ " + formatUSD(value): "-L.L " + formatLBP(value)}
                    </span>;

                },
            },
            {
                Header: "",
                accessor: "AS",
                Cell: ({row}) => {
                    return <button className="details" onClick={() => {
                    }}>Details</button>;
                },
            },
            {
                Header: "",
                accessor: "yes",
                Cell: ({row}) => {
                    return (
                        <div className="yesNo">
                            <button
                                className="yes"
                                onClick={(e) => {
                                    e.stopPropagation();
                                    handleApproveDecline(row.original.Transaction, "Approve");
                                }}
                            >
                                <FontAwesomeIcon icon={faCheck}/>
                            </button>
                            <button
                                className="no"
                                onClick={(e) => {
                                    e.stopPropagation();
                                    handleApproveDecline(row.original.Transaction, "Reject");
                                }}
                            >
                                <FontAwesomeIcon icon={faXmark}/>
                            </button>
                        </div>
                    )
                },
            }

        ],
        []
    );
    const {getTableProps, getTableBodyProps, headerGroups, rows, prepareRow, selectedFlatRows} =
        useTable({columns, data}, useRowSelect,
            (hooks) => {
                hooks.visibleColumns.push((columns) => {
                    return [
                        {
                            id: 'selection',
                            Header: ({getToggleAllRowsSelectedProps}) => (
                                <Checkbox {...getToggleAllRowsSelectedProps()} />
                            ),
                            Cell: ({row}) => (
                                <Checkbox {...row.getToggleRowSelectedProps()} />
                            )
                        },
                        ...columns,
                    ]
                })
            });

    const firstPageRows = rows.slice(0, 10);
    return (
        <div className="row approval">
            {
                !approveListLoading ? (
                    <div className={activeRowIndex === -1 ? "col-10" : "col-8"}>
                        <div className="topTable">
                            <div className="title">AWAITING APPROVAL</div>
                            <button className="approveBtn" onClick={handleApprove} disabled={selectedFlatRows.length === 0}>APPROVE</button>
                        </div>
                        <TableSelect
                            headerGroups={headerGroups}
                            page={firstPageRows}
                            prepareRow={prepareRow}
                            getTableProps={getTableProps}
                            getTableBodyProps={getTableBodyProps}
                            activeRowIndex={activeRowIndex}
                            setActiveRowIndex={setActiveRowIndex}
                            setAmountDetails={setAmountDetails}
                            setVisible={setVisible}
                            removeRowListen={false}
                        />

                    </div>
                ) : (
                    <TableSkeleton/>
                )
            }

            <TransactionDetails
                activeRowIndex={activeRowIndex}
                setActiveRowIndex={setActiveRowIndex}
                visible={visible}
                setVisible={setVisible}
                TransactionID={amountDetails}
            />
        </div>
    );
}

export default ApprovalList;